export default class InvalidAddressDetailsError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'InvalidAddressDetailsError';

        Object.setPrototypeOf(this, InvalidAddressDetailsError.prototype);
    }
}
